import React from "react";
import styles from "./SpecialistInput.module.css";
import { FiSearch } from "react-icons/fi";

const SpecialistInput = () => {
  return (
    <div>
      <div className={styles.parent_container}>
        <div className={styles.search_section}>
          <FiSearch color="white" size="1.7rem" />
          <input
            className={styles.search_input}
            type="text"
            placeholder="Search Specialist by name"
          />
        </div>
      </div>
    </div>
  );
};

export default SpecialistInput;
